import { render } from "./SetSecurityCode.vue?vue&type=template&id=5b619120&scoped=true"
import script from "./SetSecurityCode.vue?vue&type=script&lang=js"
export * from "./SetSecurityCode.vue?vue&type=script&lang=js"

import "./SetSecurityCode.vue?vue&type=style&index=0&id=5b619120&lang=less&scoped=true"

import exportComponent from "D:\\28\\前端\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b619120"]])

export default __exports__